import { render, staticRenderFns } from "./UserOnlyView.vue?vue&type=template&id=8b4d5d64&scoped=true&"
import script from "./UserOnlyView.vue?vue&type=script&lang=js&"
export * from "./UserOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./UserOnlyView.vue?vue&type=style&index=0&id=8b4d5d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4d5d64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VDivider,VFlex,VLayout,VSnackbar,VTextField})
